import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Zap } from 'lucide-react';
import { heroData, stationImage } from '../data/mock';

const Hero = ({ onNavigate }) => {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-white">
      {/* Background accent */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-br from-yellow-50 to-green-50 opacity-60 -z-10" />
      
      <div className="container mx-auto px-6 py-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left content */}
          <div className="space-y-8 animate-fade-in">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-yellow-100 rounded-full border border-yellow-300">
              <Zap className="w-4 h-4 text-yellow-600" />
              <span className="text-sm font-medium text-yellow-800">
                Seulement 1,99€ par location
              </span>
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-bold leading-tight text-gray-900">
              {heroData.title}
            </h1>
            
            <p className="text-xl text-gray-600 leading-relaxed">
              {heroData.subtitle}
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button 
                size="lg" 
                className="bg-yellow-500 hover:bg-yellow-600 text-gray-900 font-semibold text-lg px-8 py-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
                onClick={() => onNavigate('locations')}
              >
                {heroData.cta}
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
              
              <Button 
                size="lg" 
                variant="outline"
                className="border-2 border-green-500 text-green-700 hover:bg-green-50 font-semibold text-lg px-8 py-6 rounded-xl transition-all duration-300"
                onClick={() => onNavigate('partner')}
              >
                {heroData.ctaPartner}
              </Button>
            </div>
            
            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-gray-200">
              <div>
                <div className="text-3xl font-bold text-yellow-600">50+</div>
                <div className="text-sm text-gray-600 mt-1">Bornes actives</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-green-600">24/7</div>
                <div className="text-sm text-gray-600 mt-1">Disponibilité</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-yellow-600">10k+</div>
                <div className="text-sm text-gray-600 mt-1">Locations/mois</div>
              </div>
            </div>
          </div>
          
          {/* Right image */}
          <div className="relative lg:pl-12 animate-slide-in">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-r from-yellow-200 to-green-200 rounded-3xl blur-2xl opacity-30 animate-pulse-slow" />
              <img 
                src={stationImage}
                alt="Borne JYA de location de batteries"
                className="relative rounded-2xl shadow-2xl w-full max-w-md mx-auto hover:scale-105 transition-transform duration-500"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
